import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListHorizontComponent } from './list-horizont/list-horizont.component';

const routes: Routes = [
  // { path: '', pathMatch: 'full', redirectTo: '/' },
  { path: '', component: ListHorizontComponent, data: {animation: 'Home'} },
  { path: 'podcast/:slug', component: ListHorizontComponent, data: {animation: 'About'} },
  { path: 'page/:pageslug', component: ListHorizontComponent, data: {animation: 'About'} },
  { path: 'archive/:artxibo', component: ListHorizontComponent, data: {animation: 'About'} },
  { path: '**', redirectTo: ''},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
